export default "/assets/images/mila-feed-10.mp4?aba4e1a9e5b9ff945106d020518cd7d4";